'use client';

import { FC } from 'react';
import { Content } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';

import { useVisible } from '@/hooks';
import { Questions } from '../index';

import styles from './styles.module.scss';

type Props = {
  slice: Content.QuestionsAnswersSlice;
};

export const QuestionsAnswersInner: FC<Props> = ({ slice }) => {
  const [isVisibleTitle, titleId] = useVisible();

  return (
    <div className={styles.inner}>
      <div className={`${styles.box} ${styles.titleBox}`}>
        <div
          id={titleId}
          className={isVisibleTitle ? styles.titleActive : styles.title}
        >
          <PrismicRichText field={slice.primary.title} />
        </div>
      </div>
      <div className={styles.box}>
        <Questions questions={slice.primary.questions} />
      </div>
    </div>
  );
};
